module.exports = __webpack_public_path__ + "img/Tessellate08.eff90f1e.jpg";